import styles from './PageNotFound.module.css';
import { PageNotFoundView } from './pageNotFoundView';

const PageNotFound = () => {
    return (
        <div className={styles.PageNotFound}>
            <PageNotFoundView />
        </div>
    );
};

// eslint-disable-next-line import/no-default-export
export default PageNotFound;
